var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProteinFish3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1085 42.345C35.8874 43.7667 33.2091 44.5979 30.3276 44.5979C22.6436 44.5979 16.4142 38.6967 16.4142 31.4175M30.3268 18.2371C36.6624 18.2371 42.0144 22.2529 43.6907 27.7429M47.661 31.4176C47.661 40.4847 39.9019 47.8351 30.3305 47.8351C20.7591 47.8351 13 40.4847 13 31.4176C13 22.3504 20.7591 15 30.3305 15C39.9019 15 47.661 22.3504 47.661 31.4176Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.689 35.7395C46.4232 33.8584 47.5961 32.3274 48.9168 31.3562C49.0692 31.2425 48.9676 31.0106 48.7736 31.0412C48.7736 31.0412 45.4627 30.3632 41.533 32.0211C39.5935 29.3746 34.8418 25.2625 30.0947 23.6002C23.9531 21.4523 17.3035 23.224 14.616 24.1339C13.9418 24.3614 13.6416 25.105 13.9879 25.7C15.3594 28.0622 19.0213 33.3991 25.4031 35.6345C30.2564 37.3318 36.8136 37.065 40.0968 36.2294C42.004 39.764 44.8116 41.212 44.8116 41.212C44.9363 41.352 45.1764 41.2426 45.1348 41.0589C44.7977 39.5059 44.9547 37.6205 45.689 35.7395Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5662 22.5984C25.9536 21.8635 30.3589 20.9186 33.8731 22.5241C34.4318 22.7822 34.0624 23.0096 33.7715 23.1846C32.9818 23.6483 32.4785 24.007 32.3538 24.5888",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.745,
    cy: 35.505,
    rx: 4.745,
    ry: 4.505
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7431 31.5C29.3868 31.5 27.5 33.3063 27.5 35.5064C27.5 37.7065 29.3868 39.5128 31.7431 39.5128C34.0994 39.5128 35.9862 37.7065 35.9862 35.5064C35.9862 33.3063 34.0994 31.5 31.7431 31.5ZM27 35.5064C27 33.005 29.1365 31 31.7431 31C34.3497 31 36.4862 33.005 36.4862 35.5064C36.4862 38.0078 34.3497 40.0128 31.7431 40.0128C29.1365 40.0128 27 38.0078 27 35.5064Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7446 31C31.8827 31 31.9946 31.1119 31.9946 31.25V39.7628C31.9946 39.9009 31.8827 40.0128 31.7446 40.0128C31.6065 40.0128 31.4946 39.9009 31.4946 39.7628V31.25C31.4946 31.1119 31.6065 31 31.7446 31Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 35.5064C27 35.3683 27.1119 35.2563 27.25 35.2563H36.2362C36.3743 35.2563 36.4862 35.3683 36.4862 35.5064C36.4862 35.6445 36.3743 35.7563 36.2362 35.7563H27.25C27.1119 35.7563 27 35.6445 27 35.5064Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3798 32.3247C28.4747 32.2244 28.633 32.2201 28.7332 32.3151L35.0873 38.3344C35.1875 38.4294 35.1918 38.5876 35.0968 38.6878C35.0019 38.7881 34.8436 38.7924 34.7434 38.6974L28.3893 32.6781C28.2891 32.5831 28.2848 32.4249 28.3798 32.3247Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0968 32.3247C35.1918 32.4249 35.1875 32.5831 35.0873 32.6781L28.7332 38.6974C28.633 38.7924 28.4747 38.7881 28.3798 38.6878C28.2848 38.5876 28.2891 38.4294 28.3893 38.3344L34.7434 32.3151C34.8436 32.2201 35.0019 32.2244 35.0968 32.3247Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0864 25.9098C20.4179 25.9098 20.6867 25.6552 20.6867 25.3411C20.6867 25.0271 20.4179 24.7725 20.0864 24.7725C19.7549 24.7725 19.4861 25.0271 19.4861 25.3411C19.4861 25.6552 19.7549 25.9098 20.0864 25.9098Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8168 25.5249C24.8168 25.5249 25.8004 28.7533 22.4571 30.28",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4987 24.9475C26.4987 24.9475 28.0272 29.7245 23.0262 31.9424",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinFish3);
export default __webpack_public_path__ + "static/media/protein-fish3.2ee28140724b81350c08c56b14a4706d.svg";
export { ForwardRef as ReactComponent };